import { Locale, Env } from '@shopee-user/global';
import { config } from '@shopee-user/platform';
import { AuthenticateChannel } from '@tob/shared/thirdparty-auth/core/types';

const GOOGLE_THIRD_PARTY_CLIENT_ID_MAP_LIVE: Partial<Record<Locale, string>> = {
  [Locale.MY]:
    '352917009763-9vudi3rmj7un93hneecumn3mjl16l493.apps.googleusercontent.com',
  [Locale.SG]:
    '1058311263319-h6v47h7mbdt9jca2r0t555n0hk9ubbpu.apps.googleusercontent.com',
  [Locale.VN]:
    '385505213011-322s3ltr1d63jeleknbjc97c72u4n2hj.apps.googleusercontent.com',
  [Locale.TH]:
    '75446668881-b5flcg2h8sv4r8b60ndchtifq22acjth.apps.googleusercontent.com',
  [Locale.ID]:
    '428243074151-k1r4nvsgh8mrug5eshac43neuctiafkh.apps.googleusercontent.com',
  [Locale.PH]:
    '476261162790-uof31tue8b3m2lrmu83lqdkc2sk1mmkt.apps.googleusercontent.com',
};

const GOOGLE_THIRD_PARTY_CLIENT_ID_MAP_NON_LIVE: Partial<Record<
  Locale,
  string
>> = {
  [Locale.MY]:
    '40823097000-dvnbsj9tjehjp1j1t7vjkg3uv425ot7t.apps.googleusercontent.com',
  [Locale.SG]:
    '40823097000-t1ncl0rf2rb6tabc6ihjd2dk04ueuq8q.apps.googleusercontent.com',
  [Locale.VN]:
    '40823097000-mm062tri07a9ht239qq4lupdm3nnt3co.apps.googleusercontent.com',
  [Locale.TH]:
    '40823097000-o7mb9c0qj0n6icteioa5kr1iaujuh8bh.apps.googleusercontent.com',
  [Locale.ID]:
    '40823097000-j7sgdcod1gbc8cktls9ga6o7crik5fil.apps.googleusercontent.com',
  [Locale.PH]:
    '40823097000-ba1egdq6nl0i9605hv2r093vcbdrgo9i.apps.googleusercontent.com',
};

const APPLE_THIRD_PARTY_CLIENT_ID_MAP_LIVE: Partial<Record<Locale, string>> = {
  [Locale.MY]: '',
  [Locale.SG]: '',
  [Locale.VN]: '',
  [Locale.TH]: '',
  [Locale.ID]: '',
  [Locale.PH]: '',
};

const APPLE_THIRD_PARTY_CLIENT_ID_MAP_NON_LIVE: Partial<Record<
  Locale,
  string
>> = {
  [Locale.MY]: 'com.shopee.express.test.my.service',
  [Locale.SG]: '',
  [Locale.VN]: 'com.shopee.express.test.vn.service',
  [Locale.TH]: 'com.shopee.express.test.th.service',
  [Locale.ID]: '',
  [Locale.PH]: 'com.shopee.express.test.ph.service',
};

export const getWebThirdPartyClientId = ({
  channel,
}: {
  channel: AuthenticateChannel;
}) => {
  const isLiveEnv = config.ENV === Env.Live || config.ENV === Env.Liveish;

  switch (channel) {
    case AuthenticateChannel.Google: {
      const clientId = isLiveEnv
        ? GOOGLE_THIRD_PARTY_CLIENT_ID_MAP_LIVE[config.LOCALE]
        : GOOGLE_THIRD_PARTY_CLIENT_ID_MAP_NON_LIVE[config.LOCALE];
      return clientId;
    }
    case AuthenticateChannel.Apple: {
      const clientId = isLiveEnv
        ? APPLE_THIRD_PARTY_CLIENT_ID_MAP_LIVE[config.LOCALE]
        : APPLE_THIRD_PARTY_CLIENT_ID_MAP_NON_LIVE[config.LOCALE];
      return clientId;
    }
    case AuthenticateChannel.Facebook:
      return '3979303062301240';
    case AuthenticateChannel.Shopee:
      return 'shopee-express-nss';
    default:
      return '';
  }
};
